<template>
  <div id="main_container" :style="{ height: window.height + 'px' }" class="col-24 no-padding">
    <div id="login"
         class="col-xl-14 offset-xl-5 col-lg-18 offset-lg-3 col-md-22 offset-md-1 offset-0 col-24">
      <div class="row">
        <div id="boxLogin" class="col-lg-24">
          <div class="LoginHeader">
            <img src="../../../static/img/logoRiva.png" alt="logo" class="logo-header" @click="link('Login')"/>
            <el-select v-model="language" @change="setLang()">
              <el-option
                v-for="item in languages"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <icon name="riv-contacts" scale="2" class="icona-contattaci pointer" @click.native="link('Support')"></icon>
          </div>
          <router-view :language="language" @link="link"></router-view>
          <div :class="['LoginFooter', {isHiddenFooter: isHiddenFooter}]">
            <!--<span @click="link('Registrazione')">{{$t('index.footer.register')}}</span> |-->
            <!--<span @click="link('Recovery')">{{$t('index.footer.recPassword')}}</span> |-->
            <!--<a href="static/docs/Privacy_it_IT.pdf" target="_blank">{{$t('index.footer.privacy')}}</a> |
            <a href="static/docs/Cookie_it_IT.pdf" target="_blank">{{$t('index.footer.cookies')}}</a> |-->
            <span @click="link('DocumentiGenerici')">{{$t('index.footer.documenti')}}</span> |
            <a href="static/docs/Requisiti_minimi_sistema_it_IT.pdf" target="_blank">{{$t('index.footer.systemReq')}}</a><!-- |
            <span @click="link('Support')">{{$t('index.footer.support')}}</span>-->
          </div>
          <!--
          <div class="icon" @click="actionBox">
            <icon v-if="showBox" name="riv-arrowDown" flip="vertical" scale="3"></icon>
            <icon v-else name="riv-arrowDown" flip="horizontal" scale="3"></icon>
          </div>
          -->
        </div>
      </div>
      <!--
      <div class="row clearfix boxInfo" v-if="showBox">
        <div class="col-24 col-lg-8 info">
          <div class="">
            <img src="../../../static/img/caschetto.png">
            <h1 v-html="$t('index.footer.info')"></h1>
          </div>
        </div>
        <div class="col-24 col-lg-8 manuale">
          <div class="">
            <img src="../../../static/img/manuale.png">
            <h1 v-html="$t('index.footer.manual')"></h1>
          </div>
        </div>
        <div class="col-24 col-lg-8 supporto">
          <div class="" @click="link('Support')">
            <img src="../../../static/img/chiaveInglese.png">
            <h1 v-html="$t('index.footer.support')"></h1>
          </div>
        </div>
      </div>
      -->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Index',
    mounted: function () {
    },
    computed: {
      isHiddenFooter: function () {
        let found = false
        this.hiddenPaths.forEach(path => {
          if (this.$route.name && this.$route.name.substring(0, path.length).toLowerCase() === path.toLowerCase()) {
            found = true
          }
        })
        return found
      }
    },
    data () {
      return {
        window: {
          height: 0
        },
        languages: [{
          value: 'de_DE',
          label: 'DE'
        }, {
          value: 'en_GB',
          label: 'EN'
        }, {
          value: 'es_ES',
          label: 'ES'
        }, {
          value: 'fr_FR',
          label: 'FR'
        }, {
          value: 'it_IT',
          label: 'IT'
        }],
        language: 'it_IT',
        hiddenPaths: [
          'documentigenerici'
        ],
        showBox: false
      }
    },
    i18n: {
      messages: {
        it_IT: {
          index: {
            app: {
              title: 'Area Fornitori'
            },
            footer: {
              register: 'Registrati',
              recPassword: 'Recupera Credenziali',
              privacy: 'Privacy',
              cookies: 'Cookies',
              systemReq: 'Requisiti di Sistema',
              info: 'Info <span>Portale</span>',
              manual: 'Manuale <span>Operativo</span>',
              support: 'Supporto',
              documenti: 'Documenti'
            }
          }
        },
        en_GB: {
          index: {
            app: {
              title: 'Suppliers\' Area'
            },
            footer: {
              register: 'Register',
              recPassword: 'Recover',
              privacy: 'Privacy',
              cookies: 'Cookies',
              systemReq: 'System Requirements',
              info: '<span>Portal</span> Info',
              manual: '<span>Operating</span> Handbook',
              support: 'Support',
              documenti: 'Documents'
            }
          }
        },
        es_ES: {
          index: {
            app: {
              title: 'Área Proveedores'
            },
            footer: {
              register: 'Registro',
              recPassword: 'Recuperar Contraseña',
              privacy: 'Protección de datos',
              cookies: 'Cookies',
              systemReq: 'Requisitos del sistema',
              info: 'Info <span>Portal</span>',
              manual: 'Manual <span>de Operaciones</span>',
              support: 'Soporte',
              documenti: 'Documentos'
            }
          },
        },
        fr_FR: {
          index: {
            app: {
              title: 'Session Fournisseurs'
            },
            footer: {
              register: 'Enregistrement',
              recPassword: 'Récupération',
              privacy: 'Privacy',
              cookies: 'Cookies',
              systemReq: 'Configuration Système',
              info: 'Info <span>Portail</span>',
              manual: 'Mode <span>d\'Emploi</span>',
              support: 'Assistance',
              documenti: 'Documents'
            }
          }
        },
        de_DE: {
          index: {
            app: {
              title: 'Bereich Lieferanten'
            },
            footer: {
              register: 'Registriere dich',
              recPassword: 'Wiederherstellen',
              privacy: 'Privacy',
              cookies: 'Cookies',
              systemReq: 'Systemanforderungen',
              info: 'Info <span>Portal</span>',
              manual: '<span>Handbuch</span>',
              support: 'Service',
              documenti: 'Dokumente'
            }
          }
        }
      }
    },
    beforeMount: function () {
      if (sessionStorage.getItem('codLang') === null) {
        sessionStorage.setItem('codLang', this.language)
      } else {
        this.language = sessionStorage.getItem('codLang')
      }
      this.$root.$i18n.locale = this.language
    },
    mounted: function () {
      this.$nextTick(function () {
        let _this = this
        let setHeight = function () {
          _this.window.height = window.innerHeight
        }
        setHeight()
        window.addEventListener('resize', () => {
          setHeight()
        })
      })
    },
    methods: {
      actionBox: function () {
        this.showBox = !this.showBox
        this.window.height = document.getElementById('main_container').clientHeight
      },
      link: function (route) {
        this.$router.push({name: route})
      },
      setLang: function () {
        sessionStorage.setItem('codLang', this.language)
        this.$root.$i18n.locale = this.language
      }
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  #main_container {
    //height: 100% !important;
    //background-image: url(../../../static/img/background.png);
    width: 100%; height: 100%; top: 0; left: 0;
    background: url(../../../static/img/background.png) no-repeat center top; z-index: -1;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow-y: scroll;
    position: fixed;

    //background-size: cover;
    //background-position: center top;
    //margin: auto;
    display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */
    //display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
    //display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox; /* TWEENER - IE 10 */
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items: center;
    #login {
      .set-font();
      margin: auto;
      #boxLogin {
        padding: 0;
        background-image: url(../../../static/img/boxLogin.png);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center top;
        .LoginHeader {
          text-align: left;
          background-color: #fff;
          font-size: 0;
          padding: 5px 20px;
          img {
            width: 90px;
            height: 90px;
            cursor: pointer;
          }
          .icona-contattaci {
            float: right;
            margin-right: 20px;
            height: 65px;
            margin-top: 10px;
          }
          .el-select {
            float: right;
            width: 40px;
            padding-top: 22px;
            .el-input {
              input {
                .set-font(@weight: 300,@size: 18px, @color: #000);
                padding-right: 0;
                border: none;
                border-left: 1px solid #dcdfe6;
                border-radius: 0px;
              }
            }
            .el-input__suffix {
              display: none;
            }
          }
        }
        .icon {
          svg {
            color: #fff;
            width: 100%
          }
        }
        .isHiddenFooter {
          display: none;
        }
        .LoginFooter {
          padding: 15px 50px;
          //position: absolute;
          //bottom: 10px;
          width: 100%;
          text-align: right;
          color: #666e76;
          font-style: italic;
          span, a {
            .set-font(@weight: 300,@size: 14px, @color: #fff);
            cursor: pointer;
            //text-decoration: none;
            padding: 10px;
            //font-size: 16px;
            transition: color .3s;
            &:first-child {
              padding-left: 0;
            }
            &:last-child {
              padding-right: 0;
            }
            &:hover {
              color: #000;
            }
          }
        }
        label {
          width: 20%;
          display: inline-block;
        }
      }
      .boxInfo {
        div {
          padding: 6px 2px 0 2px;
          &.info {
            padding-left: 0;
            padding-right: 4px;
            div {
              background-color: #27c789;
              //background-image: url(../../../static/img/caschetto.png);
              background-size: cover;
              background-position: center top;
              cursor: pointer;
            }
          }
          &.manuale {
            div {
              background-color: #1171ea;
              //background-image: url(../../../static/img/manuale.png);
              background-size: cover;
              background-position: center top;
              cursor: pointer;
            }
          }
          &.supporto {
            padding-left: 4px;
            padding-right: 0;
            div {
              background-color: #6f3dae;
              //background-image: url(../../../static/img/chiaveInglese.png);
              background-size: cover;
              background-position: center top;
              cursor: pointer;
            }
          }
          div {
            height: 200px;
            //background-color: #10d823;
            padding: 0px;
            img {
              float: right;
              margin-top: 10px;
            }
            h1 {
              .set-font(@weight: 900,@size: 20px, @color: #fff);
              position: absolute;
              bottom: 10px;
              width: 100%;
              text-align: left;
              left: 0;
              padding-left: 30px;
              span {
                .set-font(@weight: 300,@size: 20px, @color: #fff);
              }
            }
          }
        }
      }
    }
    .el-select-dropdown__list {
      background-color: rgba(245, 245, 245, 1);
      :hover {
        background-color: #f6f5f5;
      }
      .el-select-dropdown__item {
        .set-font(@weight: 300,@size: 18px, @color: #000);
        border-bottom-color: #f6f5f5;
      }
    }
    .el-popper[x-placement^=bottom] .popper__arrow::after {
      border-bottom-color: #f5f5f5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/Index.vue